import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Pagination,
  Typography,
} from "@mui/material";
import { PaginationDetails } from "../../Utils/UtilsReq";
import CommentDetailsDialog from "./CommentDetailsDialog";
import CommentApproveDialog from "./CommentApproveDialog";
import CommentRejectDialog from "./CommentRejectDialog";

import styles from "./CommentList.module.css";

const SubmitedList = ({ data }) => {
  const submittedComments = Array.isArray(data)
    ? data.filter((comment) => comment.status === 1)
    : [];

  const { page, count, handleChange, _DATA } = PaginationDetails(
    submittedComments
  );
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isApproveDialogOpen, setIsApproveDialogOpen] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);

  const handleClick = (commentId) => {
    setSelectedCommentId(commentId);
    setIsDialogOpen(true);
  };

  const handleApproveClick = (commentId) => {
    setSelectedCommentId(commentId);
    setIsApproveDialogOpen(true);
  };

  const handleRejectClick = (commentId) => {
    setSelectedCommentId(commentId);
    setIsRejectDialogOpen(true);
  };

  return (
    <>
      <div className={styles.container}>
        {_DATA.currentData().map((comment) => (
          <Card key={comment.reviewId} className={styles.card}>
            <CardContent>
              <div className={styles.buttonContainer}>
                <Typography
                  variant="h6"
                  className={styles.text1}
                  onClick={() => handleClick(comment.reviewId)}
                >
                  {comment.review}
                </Typography>
                <div className={styles.rightButtonContainer}>
                  <Button
                    variant="contained"
                    className={styles.completeButton}
                    onClick={() => handleApproveClick(comment.reviewId)}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    className={styles.completeButton}
                    onClick={() => handleRejectClick(comment.reviewId)}
                  >
                    Reject
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
          className={styles.pagination}
        />
        {isDialogOpen && (
          <CommentDetailsDialog
            onClose={() => setIsDialogOpen(false)}
            reqId={selectedCommentId}
          />
        )}
        {isApproveDialogOpen && (
          <CommentApproveDialog
            onClose={() => setIsApproveDialogOpen(false)}
            reqId={selectedCommentId}
          />
        )}
        {isRejectDialogOpen && (
          <CommentRejectDialog
            onClose={() => setIsRejectDialogOpen(false)}
            reqId={selectedCommentId}
          />
        )}
      </Box>
    </>
  );
};

export default SubmitedList;
